import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Row, Col} from 'reactstrap';
import OtpVerificationComponent from './OtpVerificationComponent';
import Config from '../../../../Config';
import {isMobile} from 'react-device-detect';
import {otpOrigin} from 'app/Components/Block/OTPLoginBlock/Assets/variables';

const OtpVerificationPageWithImage = (props) => {
  return (
    <div className='otp-verification_page_with_banner'>
      {props.otpBanner && (
        <Row className='justify-content-md-center otp-banner-wrapper text-center'>
          <Col className='p-0 banner-content'>
            <Image src={Config.epiBaseUrl + props.otpBanner} alt='banner' />
            <label dangerouslySetInnerHTML={{__html: props.otpTitles?.bannerMainTitle}} className='main-banner-title-text' />
            <label
              dangerouslySetInnerHTML={{__html: props.otpTitles?.bannerSecondTitle}}
              className={`second-banner-title-text ${isMobile ? 'margin-mobile' : ''}`}
            />
          </Col>
        </Row>
      )}
      <OtpVerificationComponent
        otpOrigin={otpOrigin.ABROAD}
        originProcess={props.originProcess}
        otpTitles={props.otpTitles}
        onAuthenticatedAction={props.onAuthenticatedAction}
        isInline={props.isInline}
      />
    </div>
  );
};

export default OtpVerificationPageWithImage;
